export default class Identity {
  account: any
  accesstoken: any
  tokenexpiry: any

  constructor(tokenResponse) {
    this.account = tokenResponse.account
    this.accesstoken = tokenResponse.accessToken
    this.tokenexpiry = tokenResponse.expiresOn
  }

  get userId() {
    return this.account.homeAccountId
  }

  get emailAddress() {
    return this.account.username
  }

  get name() {
    return this.account.name
  }

  get accessToken() {
    return this.accesstoken
  }

  get tokenExpiry() {
    return this.tokenexpiry
  }
}
